module.exports = __webpack_public_path__ + "img/1695260430990-image.jpg.74147c36.webp";